import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class BscobrancaTranslate {

  constructor(private translate: TranslateService) {

  }

  getText(messageCode: string): string {
     let message: string;
     this.translate.get(messageCode).subscribe( (text: string) => {
            message = text;
        });
     return message;
  }

}
